
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { PieChart } from '@mui/x-charts/PieChart';
import { useDrawingArea } from '@mui/x-charts/hooks';
import * as React from 'react';


const StyledText = styled('text')(({ theme }) => ({
  fill: theme.palette.text.primary,
  textAnchor: 'middle',
  dominantBaseline: 'central',
  fontSize: 20,
  fontWeight: 'bold'
}));

function PieCenterLabel({ children }) {
  const { width, height, left, top } = useDrawingArea();
  return (
    <StyledText x={left + width / 2} y={top + height / 2}>
      {children}
    </StyledText>
  );
}

export const PieChartComponent = ({ chartData, size,centerValue, centerLabel }) => {
  const maxChartDataObj = chartData.reduce((max, current) => (current.value > max.value ? current : max), chartData[0]);
  return (
    <PieChart series={[{
      paddingAngle: 8,
      innerRadius: 100,
      outerRadius: 130,
      data: chartData,
    }]} {...size} legend={{ hidden: true }}>
      <PieCenterLabel>
        {centerValue}
        <br /> {centerLabel}</PieCenterLabel>
    </PieChart>
  );
}
